/* eslint-disable */
import axios from 'axios'
import Vue from 'vue'
const vm = new Vue()


const service = axios.create({
  baseURL: process.env.VUE_APP_API_URL
  // timeout: 5000
})
window._axiosPromiseArr = []

// request interceptors
service.interceptors.request.use(config => {
  if (localStorage.token) {
    config.cancelToken = new axios.CancelToken(cancel => {
      window._axiosPromiseArr.push({ cancel })
    })
    config.headers['Authorization'] = 'Bearer ' + localStorage.token
  }
  return config
}, error => {
  // Do something with request error
  console.log(error) // for debug
  Promise.reject(error)
})
// respone interceptors
service.interceptors.response.use(
  response => {
    if (response.status !== 200) {
      if (response.status === 401) {
        vm.$message({
          message: 'Anauthorized!',
          type: 'error',
          duration: 5 * 1000
        })
        return Promise.reject(new Error('error'))
      }
      vm.$message({
        message: response.response,
        type: 'error',
        duration: 5 * 1000
      })
      return Promise.reject(new Error('error'))
    } else {
      if (response.config.url === '/backend/secret/metadataDownload' ||
      response.config.url === '/backend/secret/downloadBatchUpdateTemplate') {
        return response
      } else {
        return response.data
      }
    }
  },
  err => {
    const status = err.response.status
    console.log(err)
    if (status === 401 && window.location.hash.indexOf('/login') === -1) {
    vm.$message({
      message: err.response.data.errorMessage,
      type: 'error',
      duration: 5 * 1000
    })
      localStorage.token = ''
      if (localStorage.redirectUrl) {
        window.location.href = localStorage.redirectUrl
      } else {
        window.location.href = err.response.headers.redirecturl
        // location.reload()
      }
    } else if (status === 504) {
      vm.$message({
        message: 'Gateway timeout',
        type: 'error',
        duration: 5 * 1000
      })
    } else if (status === 403) {
      vm.$message({
        message: err.response.data.errorMessage || 'Current IP is not allowed to access CSMS console',
        type: 'error',
        duration: 5 * 1000
      })
    } else {
      vm.$message({
        message: err.response.data.errorMessage || 'Internal server error',
        type: 'error',
        duration: 5 * 1000
      })
    }
    return Promise.reject(err)
  }
)

export default service
